<div class="admin-panel">
  <h2>Panneau d'administration</h2>

  <div class="admin-panel__header">
    <h3>Utilisateurs en attente de validation</h3>
    <button (click)="loadPendingUsers()" class="btn-refresh" [disabled]="loading">
      🔄 Actualiser
    </button>
  </div>

  @if (loading) {
    <div class="loading">Chargement...</div>
  }

  @if (error) {
    <div class="error">{{ error }}</div>
  }

  @if (!loading && pendingUsers.length === 0) {
    <div class="empty">
      Aucun utilisateur en attente
    </div>
  }

  @if (!loading && pendingUsers.length > 0) {
    <div class="users-list">
      @for (user of pendingUsers; track user) {
        <div class="user-card">
          <div class="user-info">
            <h4>{{ user.displayName || user.username }}</h4>
            <p><strong>Email:</strong> {{ user.email }}</p>
            <p><strong>Username:</strong> {{ user.username }}</p>
            <p class="date"><strong>Inscription:</strong> {{ user.createdAt | date:'short' }}</p>
          </div>
          <div class="user-actions">
            <button (click)="approveUser(user.id)" class="btn-approve">
              ✅ Approuver
            </button>
            <button (click)="rejectUser(user.id)" class="btn-reject">
              ❌ Rejeter
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
